import { Box } from "@prismicio/editor-ui"
import type { PropsWithChildren } from "react"

// TODO: [PBD-2122] Remove this component when `HeaderTabLink` has been reworked.
export function SettingsPageBodyTabs(props: PropsWithChildren) {
  const { children } = props
  return (
    <Box gap={16} height={48} margin={{ inline: "-8" }} position="relative">
      <Box
        position="absolute"
        bottom={0}
        height="1px"
        left="8px"
        right="8px"
        backgroundColor="grey7"
      />
      {children}
    </Box>
  )
}
